/***********************************************************
 * Generated by RxDjango on 2026-05-14 19:30 (UTC)         *
 *                                                         *
 * Based on all ContextChannel subclasses in memo.channels *
 *                                                         *
 *                  DO NOT EDIT THIS FILE                  *
 *                                                         *
 * To rebuild it, run:                                     *
 *                                                         *
 *     ./manage.py makefrontend [memo]                     *
 *                                                         *
 ***********************************************************/

import { ContextChannel } from '@rxdjango/react';

const SOCKET_URL = (process.env.REACT_APP_RX_WEBSOCKET_URL ?? 'ws://localhost:8000') as string;

export class CarouselMemoChannel extends ContextChannel {

  protected endpoint: string = "/ws/memo/";
  protected baseURL: string = SOCKET_URL;

  selected: number = 0;
  fruit: string = 'banana';
  first_letter: string = 'b';

  rotate = async () => {
    return await this.rx.callAction('rotate', []);
  };
}
